import DeltaWifiBookNow from './DeltaWifiBookNow';

export default DeltaWifiBookNow;
